export enum Locale {
  EN = 'EN',
  ID = 'ID'
}

export const SUPPORTED_LOCALES: string[] = [Locale.ID, Locale.EN];
export const DEFAULT_LOCALE = Locale.ID;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/locale.ts